export const queryParameter = {
  checkResultDetail: {
    riskLevelHigh: 'riskLevelHigh',
    riskLevelMiddle: 'riskLevelMiddle',
    riskLevelLow: 'riskLevelLow',
    riskLevelNone: 'riskLevelNone',
    riskLevelExclude: 'riskLevelExclude',
    filterSite: 'filterSite',
  },
};
